import { ItemType } from '@/app/utils/constants/ItemType';
import { applySelection } from '@/app/utils/toolkit/business-rules/inv-strat/investment-strategy';


const rules = [
  {
    type: ItemType.INVESTMENT_STRATEGY,
    rule: 'SELECTION',
    handler: applySelection,
  },
];

function fetchBusinessRule(applyRule) {
  const businessRuleToApply = rules.find(
    rule => rule.type === applyRule.type && rule.rule === applyRule.rule,
  );
  return businessRuleToApply ? businessRuleToApply.handler : undefined;
}
export default fetchBusinessRule;
